module.exports = __webpack_public_path__ + "img/note.7411edf4.png";